import React from 'react';

const ClearSubtitleApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/clear.html"
        title="Clear Subtitle App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default ClearSubtitleApp;